// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.burger-menu {
    /* REMOVE position: absolute, top, right */
    z-index: 2000;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.burger-button {
    background-color: white;
    border: 1px solid #ccc;
    font-size: 24px;
    padding: 6px 12px;
    cursor: pointer;
}

.burger-dropdown {
    position: absolute;
    top: 40px;
    right: 0;
    background-color: white;
    border: 1px solid #ccc;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.burger-dropdown ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.burger-dropdown ul li {
    padding: 10px 20px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
}

.burger-dropdown ul li:hover {
    background-color: #f5f5f5;
}

.panel {
    position: absolute;
    top: 60px;
    right: 10px;
    background-color: white;
    border: 1px solid #ccc;
    padding: 20px;
    z-index: 1500;
    max-width: 300px;
    box-shadow: 0 6px 10px rgba(0,0,0,0.15);
}

.panel-overlay {
    position: fixed; /* ⬅️ namiesto absolute */
    top: 0;
    left: 25%;
    width: 75%;
    height: 75%;
    background-color: rgba(255, 255, 255, 0.96);
    z-index: 2500; /* vyššie než ostatné UI prvky */
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}


.panel-content {
    max-width: 600px;
    max-height: 100%;        /* allow full height within overlay */
    overflow-y: auto;        /* make scrollable */
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    text-align: center;
}

`, "",{"version":3,"sources":["webpack://./src/burger-menu.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,eAAe,EAAE,yBAAyB;IAC1C,MAAM;IACN,SAAS;IACT,UAAU;IACV,WAAW;IACX,2CAA2C;IAC3C,aAAa,EAAE,gCAAgC;IAC/C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB,SAAS,qCAAqC;IAC9D,gBAAgB,SAAS,oBAAoB;IAC7C,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;AACtB","sourcesContent":[".burger-menu {\n    /* REMOVE position: absolute, top, right */\n    z-index: 2000;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.burger-button {\n    background-color: white;\n    border: 1px solid #ccc;\n    font-size: 24px;\n    padding: 6px 12px;\n    cursor: pointer;\n}\n\n.burger-dropdown {\n    position: absolute;\n    top: 40px;\n    right: 0;\n    background-color: white;\n    border: 1px solid #ccc;\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.burger-dropdown ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.burger-dropdown ul li {\n    padding: 10px 20px;\n    cursor: pointer;\n    border-bottom: 1px solid #eee;\n}\n\n.burger-dropdown ul li:hover {\n    background-color: #f5f5f5;\n}\n\n.panel {\n    position: absolute;\n    top: 60px;\n    right: 10px;\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 20px;\n    z-index: 1500;\n    max-width: 300px;\n    box-shadow: 0 6px 10px rgba(0,0,0,0.15);\n}\n\n.panel-overlay {\n    position: fixed; /* ⬅️ namiesto absolute */\n    top: 0;\n    left: 25%;\n    width: 75%;\n    height: 75%;\n    background-color: rgba(255, 255, 255, 0.96);\n    z-index: 2500; /* vyššie než ostatné UI prvky */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n}\n\n\n.panel-content {\n    max-width: 600px;\n    max-height: 100%;        /* allow full height within overlay */\n    overflow-y: auto;        /* make scrollable */\n    background-color: #fff;\n    padding: 30px;\n    border-radius: 8px;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);\n    text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
